import ReactDOM from 'react-dom/client';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { applyFontPreference, getFontPreference } from './utils/fontPreference';
import App from './App';
import { initializeGA } from './utils/tracking';
import './global.less';
// import 'antd/dist/antd.css';

// Windows 系统字体不含国旗 emoji(🇨🇳 等会渲染成 CN 字母缩写),在这类平台注入
// 只含国旗字形的 Twemoji Country Flags 字体;配合 global.less 中 html 的 font-family 前置生效
polyfillCountryFlagEmojis();

// 应用用户的字体偏好(设置-字体,localStorage 持久化)
applyFontPreference(getFontPreference());

// 初始化 Google Analytics 4
initializeGA(import.meta.env.VITE_GA4_MEASUREMENT_ID);

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <App />,
  // </React.StrictMode>,
);
